// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Muli:400,700,900&display=swap&subset=latin-ext);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --theme: #7bdcb5;
  --white: #fff;
  --black: #000;
  --grey: #eee;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: 'Muli';
  font-weight: 400;
  background-color: var(--white);
}

body,
html {
  height: 100%;
}

.app__header {
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.app__header {
  h1 {
    margin: 0;
  }
}

.app__link {
  width: 30px;
  height: 30px;
  display: inline-block;
  vertical-align: middle;
  margin-left: 15px;
}

.app__link svg {
  fill: var(--black);
}

.container {
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: 0 15px;
}

.code {
  overflow: hidden;
  border-radius: 5px;
}

.form {
  margin: 15px 0;
}

.form h2 {
  margin: 0;
  margin-bottom: 15px;
}

.form__fields {
  background-color: var(--grey);
  border-radius: 5px;
  font-size: 0;
}

.form__field {
  display: inline-block;
  vertical-align: top;
  width: 50%;
  padding: 15px;
}

.form__field__title {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 5px;
}

.form__field__input input {
  width: 100%;
  padding: 10px 15px;
  background-color: var(--white);
  border-radius: 5px;
  border: none;
  &:focus {
    outline: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/styles.css"],"names":[],"mappings":"AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ;IACE,aAAa;EACf;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Muli:400,700,900&display=swap&subset=latin-ext');\n\n:root {\n  --theme: #7bdcb5;\n  --white: #fff;\n  --black: #000;\n  --grey: #eee;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Muli';\n  font-weight: 400;\n  background-color: var(--white);\n}\n\nbody,\nhtml {\n  height: 100%;\n}\n\n.app__header {\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.app__header {\n  h1 {\n    margin: 0;\n  }\n}\n\n.app__link {\n  width: 30px;\n  height: 30px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-left: 15px;\n}\n\n.app__link svg {\n  fill: var(--black);\n}\n\n.container {\n  width: 100%;\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 0 15px;\n}\n\n.code {\n  overflow: hidden;\n  border-radius: 5px;\n}\n\n.form {\n  margin: 15px 0;\n}\n\n.form h2 {\n  margin: 0;\n  margin-bottom: 15px;\n}\n\n.form__fields {\n  background-color: var(--grey);\n  border-radius: 5px;\n  font-size: 0;\n}\n\n.form__field {\n  display: inline-block;\n  vertical-align: top;\n  width: 50%;\n  padding: 15px;\n}\n\n.form__field__title {\n  font-weight: bold;\n  font-size: 16px;\n  margin-bottom: 5px;\n}\n\n.form__field__input input {\n  width: 100%;\n  padding: 10px 15px;\n  background-color: var(--white);\n  border-radius: 5px;\n  border: none;\n  &:focus {\n    outline: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
